import { makeEntityStringId } from 'app/types/entity';
import { makeGuid } from 'app/types/guid';

export const DAILY_NEWS_CATEGORY_ID = makeEntityStringId(makeGuid('0225ae09-5d63-41c2-bd75-693985d07d78'));

export enum CategoryQueryParam {
  CategoryId = 'category_id',
  MaximumLevel = 'max_level',
  MinimumLevel = 'min_level',
  CategoryOrder = 'order'
}
